// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"551d0608","455":"f6193293","977":"d3b83d13"}[chunkId] + ".chunk.js";
};